import { PAYMENT_STATUS, type PaymentStatusType } from "../types/common";

export interface PaymentSidebarFilterItem {
  label: string;
  /** Grouped key stored in the URL (?status=<key>) to drive sidebar selection UI. null = All. */
  status: string | null;
  /** Payment status values sent to the API as request_status param. */
  paymentStatuses: PaymentStatusType[];
  default?: boolean;
}

/**
 * Payments tab is internal-only, so a single filter set covers all users.
 */
const PAYMENT_FILTERS: PaymentSidebarFilterItem[] = [
  { label: "All payments", status: null, paymentStatuses: [], default: true },
  {
    label: "Under Review",
    status: "under_review",
    paymentStatuses: [PAYMENT_STATUS.SUBMITTED, PAYMENT_STATUS.UNDER_REVIEW],
  },
  {
    label: "Approved",
    status: "approved",
    paymentStatuses: [PAYMENT_STATUS.APPROVED],
  },
  {
    label: "Payment Recorded",
    status: "payment_recorded",
    paymentStatuses: [PAYMENT_STATUS.PAYMENT_RECORDED],
  },
  {
    label: "Rejected",
    status: "rejected",
    paymentStatuses: [PAYMENT_STATUS.REJECTED],
  },
];

export function getPaymentSidebarFilters(): PaymentSidebarFilterItem[] {
  return PAYMENT_FILTERS;
}

export function getDefaultPaymentFilterStatus(): string | null {
  return PAYMENT_FILTERS.find((f) => f.default)?.status ?? null;
}
